import { unFormatUnknownUnit } from '@/common/utils/unFormatters'
import { isBefore, parse, startOfDay } from 'date-fns'
import z from 'zod'

const modificationItemSchema = z.object({
  id: z.string(),
  original_unit_price: z.string(),
  original_warranty_in_days: z.number(),
  new_unit_price: z.string().nullable().optional(),
  new_warranty_in_days: z.string().nullable().optional(),
})

export const updateExecutionEntryEstablishmentAcceptSchema = z.object({
  start_at_date: z.string({ message: 'Campo obrigatório' }).refine(
    (value) => {
      const parsed = parse(value, 'dd/MM/yyyy', new Date())

      return !isBefore(startOfDay(parsed), startOfDay(new Date()))
    },
    { message: 'A data não pode ser anterior ao dia de hoje' },
  ),
  start_at_time: z.string({ message: 'Campo obrigatório' }),
  deadline_to_complete_in_days: z.string({ message: 'Campo obrigatório' }).refine(
    (value) => {
      return unFormatUnknownUnit(value)
    },
    { message: 'Campo obrigatório' },
  ),
  pieces: z.array(modificationItemSchema),
  activities: z.array(modificationItemSchema),
})

export type UpdateExecutionEntryEstablishmentAcceptValidationSchema = z.infer<
  typeof updateExecutionEntryEstablishmentAcceptSchema
>
